export interface APIMetricConstraint {
    id: number
    name: string
    ownerId: number
}

export interface APIMetricConstraintList {
    content: APIMetricConstraint[]
    total: number
    pageSize: number
    pageNumber: number
    pages: number
}

export function getMetricConstraintID(model: APIMetricConstraint): number {
    return model.id
}

export interface APIMeasurerMetric {
    name: string
    display_name?: string
    description?: string
}
